/* unplugin-vue-components disabled */import script from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts"

import "./VideoProfile.vue?vue&type=style&index=0&id=fb097516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb097516"]])

export default __exports__